import moment from "moment";
import { icons } from "../../assets/icons";

export const usersColumnsCreateGroup = () => [
  { Header: "Name", accessor: "name" },
  {
    Header: "Groups",
    accessor: "groups",
    Cell: (props) => {
      return <div>{props?.row?.original?.groupIds?.length || 0}</div>;
    },
  },
  {
    Header: "Last Activity",
    accessor: "updated",
    Cell: (props) => {
      return (
        <div>{props?.row?.original?.added}</div>
      );
    },
  },
  {
    Header: "Creation Time",
    accessor: "added",
    Cell: (props) => {
      return (
        <div>{props?.row?.original?.added}</div>
      );
    },
  },
];

export const usersListColumns = (deleteUser = () => {}, isDeleteEnable = true, editUsers = () => {}, userLabelHandler = () => {} ) => [
  { Header: "Name", accessor: "name" },
  // { Header: "User Level", accessor: "userLabel", Cell: (props) => {
  //   return (
  //     <div className={`cursor-pointer underline underline-offset-4 text-blue-600`} onClick={() => userLabelHandler(props?.row?.original)}>
  //       {props?.row?.original?.userLabel}
  //     </div>
  //   )
  // } },
  // {
  //   Header: "Groups",
  //   accessor: "groups",
  //   Cell: (props) => {
  //     return <div>{props?.row?.original?.groupIds?.length || 0}</div>;
  //   },
  // },
  // {
  //   Header: "Last Activity",
  //   accessor: "updated",
  //   Cell: (props) => {
  //     return <div>{props?.row?.original?.added}</div>;
  //   },
  // },
  // {
  //   Header: "Creation Time",
  //   accessor: "added",
  //   Cell: (props) => {
  //     return <div>{props?.row?.original?.added}</div>;
  //   },
  // },
  {
    Header: "Status",
    accessor: "active",
    Cell: (props) => {
      const value = props?.row?.original?.active;
      return (
        <div className={value ? "text-[--successGreen]" : "text-[--textRed]"}>
          {value ? "Active" : "Disabled"}
        </div>
      );
    },
  },
  // {
  //   Header: "Status",
  //   accessor: "actions",
  //   Cell: (props) =>
  //     isDeleteEnable ? (
  //       <div className="flex items-center gap-x-10 cursor-pointer">
  //         <img
  //           src={icons.editIcon}
  //           onClick={() => editUsers(props?.row?.original)}
  //         />
  //         <img
  //           src={icons.trashIcon}
  //           onClick={() => deleteUser(props?.row?.original.id)}
  //         />
  //         {/* <img src={icons.trashIcon} /> */}
  //       </div>
  //     ) : (
  //       <div></div>
  //     ),
  // },
];

export const usersChildListColumns = (
  deleteUser = () => {},
  isDeleteEnable = true,
  editUsers = () => {},
  userLabelHandler = () => {}
) => [
  { Header: "Name", accessor: "name" },
  {
    Header: "User Level",
    accessor: "userLabel",
    Cell: (props) => {
      return (
        <div
          className={
            props?.row?.original?.userLabel !== "Store" &&
            `cursor-pointer underline underline-offset-4 text-blue-600`
          }
          onClick={() => {
            if (props?.row?.original?.userLabel !== "Store") {
              userLabelHandler(props?.row?.original);
            }
          }}
        >
          {props?.row?.original?.userLabel}
        </div>
      );
    },
  },
  {
    Header: "Groups",
    accessor: "groups",
    Cell: (props) => {
      return <div>{props?.row?.original?.groupIds?.length || 0}</div>;
    },
  },
  {
    Header: "Last Activity",
    accessor: "updated",
    Cell: (props) => {
      return <div>{props?.row?.original?.added}</div>;
    },
  },
  {
    Header: "Creation Time",
    accessor: "added",
    Cell: (props) => {
      return <div>{props?.row?.original?.added}</div>;
    },
  },
  {
    Header: "Status",
    accessor: "active",
    Cell: (props) => {
      const value = props?.row?.original?.active;
      return (
        <div className={value ? "text-[--successGreen]" : "text-[--textRed]"}>
          {value ? "Active" : "Disabled"}
        </div>
      );
    },
  },
];
